import h from 'hyperscript';

import saveIcon from '@disy/cadenza-icons/save.svg';
import { on } from '@disy/lib/event-util';
import { icon } from '@disy/ui/icon';

import { Modal } from 'ui/dialog/modal/modal';

import i18n from './workbook-header.properties';

export const SNAPSHOT_DESCRIPTION_TEXT_MAX_LENGTH = 250;

export function createSaveAndPublishDialog() {
  const form = new SaveAndPublishWorkbookForm();
  const modal = new Modal<string | false>({
    size: 'm',
    title: i18n('save-and-publish-dialog.title'),
    titleIcon: icon(saveIcon),
    submitButton: i18n('save-and-publish-dialog.submit'),
    cancelButton: i18n('save-and-publish-dialog.cancel'),
    content: () => Promise.resolve(form),
  });
  on(modal, 'submit', () => modal.close(form.versionComment));
  on(modal, 'cancel', () => modal.close(false));
  document.body.appendChild(modal);
  return modal.connectAndShow();
}

const COMPONENT_NAME = 'd-save-and-publish-workbook-form';

class SaveAndPublishWorkbookForm extends HTMLElement {
  constructor() {
    super();
    this.classList.add(COMPONENT_NAME);
    this.append(
      h(
        '.d-alert.d-alert-small.d-alert-info',
        h('p', h('strong', i18n('save-and-publish-workbook-info.title'))),
        h('p', i18n('save-and-publish-workbook-info.message')),
      ),
      h('form-group.form-group', [
        h('label', i18n('version-input.label')),
        h('textarea.form-control.version-comment-input', {
          attrs: { maxLength: '255' },
        }),
      ]),
    );
  }

  get versionComment() {
    // Temporary cast until textarea form control is transformed to ts
    const input = this.querySelector('.version-comment-input') as unknown as { value: string };
    return input.value;
  }
}

customElements.define(COMPONENT_NAME, SaveAndPublishWorkbookForm);
